import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table';

const computeCollectionRate = (agency) => {
  if (!agency.total_billed || agency.total_billed <= 0) return 0;
  return parseFloat(((agency.total_paid / agency.total_billed) * 100).toFixed(1));
};

const AgencyRow = ({ agency }) => {
  const rate = computeCollectionRate(agency);
  const isGoodRate = rate >= 80;
  return (
    <TableRow data-testid={`ca-agency-row-${agency.agency_id}`}>
      <TableCell className="font-medium">{agency.agency_name}</TableCell>
      <TableCell className="text-right">{agency.total_patients}</TableCell>
      <TableCell className="text-right">{agency.total_claims}</TableCell>
      <TableCell className="text-right text-green-600">{agency.claims_paid}</TableCell>
      <TableCell className="text-right text-red-600">{agency.claims_denied}</TableCell>
      <TableCell className="text-right">${(agency.total_billed || 0).toLocaleString()}</TableCell>
      <TableCell className="text-right">${(agency.total_paid || 0).toLocaleString()}</TableCell>
      <TableCell className="text-right">
        <Badge className={isGoodRate ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}>
          {rate}%
        </Badge>
      </TableCell>
    </TableRow>
  );
};

const AgencyPerformanceTable = ({ agencies }) => (
  <Card className="border-slate-200" data-testid="ca-agency-performance-table">
    <CardHeader className="pb-2">
      <CardTitle className="text-base">Agency Performance</CardTitle>
    </CardHeader>
    <CardContent className="p-0">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Agency</TableHead>
            <TableHead className="text-right">Patients</TableHead>
            <TableHead className="text-right">Claims</TableHead>
            <TableHead className="text-right">Paid</TableHead>
            <TableHead className="text-right">Denied</TableHead>
            <TableHead className="text-right">Billed</TableHead>
            <TableHead className="text-right">Collected</TableHead>
            <TableHead className="text-right">Rate</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {(agencies || []).map((agency) => (
            <AgencyRow key={agency.agency_id} agency={agency} />
          ))}
        </TableBody>
      </Table>
    </CardContent>
  </Card>
);

export default AgencyPerformanceTable;
